import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoFiConfig } from './presets/contact-axo-fi.config';
import { insuranceMypageFi } from './presets/insurance-mypage.config';
import { globalFi } from './presets/global-fi.config';
import { myPageCcd2FiOptions } from './presets/mypage-ccd2-fi.config';
import { myPageOffersFiConfig } from './presets/mypage-offers-fi.config';
import { productConfigLimited } from './presets/product-config.preset';
import { organisationAxoFiConfig } from './presets/organisation-axo-fi.config';
import { serviceTrustpilotAxoFiConfig } from './presets/service-trustpilot-axo-fi.config';
import { serviceVwoUscoreConfig } from './presets/service-vwo-uscore.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansFiConfig } from './presets/unsecured-loans-fi.config';

export const global: GlobalConfig = {
  brand: 'uscore.fi',
  ...globalFi,
};

export const site: SiteConfig = {
  domain: 'uscore.fi',
  name: 'uScore',
  theme: {
    name: 'uscore-light',
    brand: 'uscore.fi',
  },
  path: {
    loansApply: '/loans/apply',
    mypage: 'https://mypage.axolaina.fi',
    insurance: '/hae/matsurvaraus',
    mypageCreditCards: '/omat-sivut/luottokortit',
    ...insuranceMypageFi,
  },
  ...organisationAxoFiConfig,
  ...contactAxoFiConfig,
  services: {
    cms: {
      provider: 'prepr',
    },
    trustpilot: { ...serviceTrustpilotAxoFiConfig, showInForms: true },
    gtm: 'GTM-MMJ8P92Z',
    ga: 'G-598Y2XNJF6',
    launchDarkly: {
      enabled: false,
    },
    ...serviceVwoUscoreConfig,
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansFiConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    ...myPageOffersFiConfig,
    ...myPageCcd2FiOptions,
  },
};

export const product: ProductConfig = productConfigLimited;
